import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { UserProfile } from '../models/user-profile'
import { UserProfileGateway } from '../gateways/user-profile-gateway'
import { User } from '../models/user'
import { User_details } from '../models/user-details'
import { SecurityQuestion } from '../models/security-question-model'
@Injectable()
export class NetworkUserProfileGateway extends UserProfileGateway {
    constructor(private http: HttpClient) {
        super()
    }

    retrieveUserProfile(): Observable<UserProfile> {
        return this.http.get<UserProfile>('../api/retrieveUserProfile')
    }

    //createWebUser(profileModel: UserProfile): Observable<UserProfile> {
    //    return this.http.post<UserProfile>('../api/createWebUser', JSON.stringify(profileModel))
    //}

    updateUserProfile(profileModel: User): Observable<User> {
        return this.http.post<User>('../api/UpdateUserProfile', JSON.stringify(profileModel))
    }
    // createUserProfile(profileModel: UserProfile): Observable<UserProfile> {
    //    return this.http.post<UserProfile>('../api/createUserProfile', JSON.stringify(profileModel))
    // }

    createUserProfile(profileModel: User): Observable<User> {
        return this.http.post<User>('../api/createUserProfile', JSON.stringify(profileModel))
    }

    findUserProfileByProfileID(profileID: number): Observable<UserProfile> {
        let getURL = '../api/userProfile/' + profileID
        return this.http.get<UserProfile>(getURL)
    }

    updateEmail(email: string, profileId: number): Observable<Boolean> {
        let getURL = '../api/updateEmail?newEmail=' + email + '&profileID=' + profileId
        //  let getURL = '../api/updateNewEmail/'+email+'/'+ profileId
        return this.http.get<Boolean>(getURL)
    }
    updateCellphoneNo(CellphoneNo: string, profileId: number): Observable<Boolean> {
        let getURL = '../api/updateNewCellphoneNo?newCellphoneNo=' + CellphoneNo + '&profileID=' + profileId
        return this.http.get<Boolean>(getURL)
    }
     updateResetPassword(newPassword: string, profileID: number): Observable<Boolean> {
        return this.http.post<Boolean>('../api/updateResetPassword', JSON.stringify({ newPassword, profileID }))
    }

    updateUserChangePasswordAndSecurityChallenge(newPassword: string, securityQuestion: number, securityAnswer: string, userProfileID: number): Observable<Boolean> {
        return this.http.post<Boolean>('../api/updateResetPasswordAndSecurityQA', JSON.stringify({newPassword, securityQuestion, securityAnswer, userProfileID}))
    }

    updateAdminPersonalDetails(profileModel: User): Observable<User> {
        return this.http.post<User>('../api/UpdateAdminPersonalDetails', JSON.stringify(profileModel))
    }
    isPasswordCorrect(password: string, profileId: number): boolean {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '../api/isPasswordCorrect', false);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify({ password, profileId }));
        return JSON.parse(xhr.responseText);
    }

    
    isPasswordCountCorrect(password: string, profileId: number): boolean {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '../api/isPasswordCountCorrect', false);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify({password, profileId}));
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }
    getFailedLoginAttempts(userName: string, failedAttemptLimit: number): number {
        var xhr = new XMLHttpRequest()

        xhr.open('GET', '../api/getFailedLoginAttempts/' + userName + '/' + failedAttemptLimit, false)
        xhr.send()
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    lockUserAccount(userName: string): void {
        var xhr = new XMLHttpRequest()
        xhr.open('GET', '../api/lockUserAccount?username=' + userName, false)
        xhr.send()
    }
    getSecurityQuestion(profileId: number): Observable<SecurityQuestion> {
        return this.http.get<any>('../api/getSecurityQuestion?profileid=' + profileId)
    }
    getSecurityQuestions(): Observable<SecurityQuestion[]> {
        return this.http.get<any>('../api/getSecurityQuestions')
    }
    getEcontractDetailsByOrgID(orgId: number): Observable<boolean> {
        return this.http.get<boolean>('../api/getEcontractDetailsByOrgID/' + orgId)
    }

    userProfileSearch(userProfileName: string, userId: number): Observable<UserProfile> {
        let getURL = '../api/searchUserProfile/' + userProfileName + '/' + userId
        return this.http.get<UserProfile>(getURL)
    }
    getUserAllDetails(userProfileID: number, planyear: string): Observable<User_details> {
        return this.http.get<User_details>(`../api/GetUserAllDetails/${userProfileID}/${planyear}`)
    }

    GetPWurl(): Observable<string> {
        return this.http.get<string>('../api/GetPwUrl')
    }

    CheckUserLoginPath(): Observable<boolean> {
        return this.http.get<boolean>('../api/CheckUserLoginPath')
    }
}
